import request from '@/utils/request'

//获取userSig
export function getUserSig(data) {
	return request({
		url: '/api/live/getImSign',
		method: 'get',
		params: data
	})
}
//聊天室禁言列表
export function listMuted(data) {
	return request({
		url: '/api/chat/listMuted',
		method: 'get',
		params: data
	})
}